<script lang="ts">
  import type { HTMLAnchorAttributes } from 'svelte/elements';
  import type { HTMLProps } from 'svelte/svelte-html';

  export let props: HTMLProps<'a', HTMLAnchorAttributes> = {};

  $: href = props?.target === '_blank' ? props.href : `/${props?.href}`;
</script>

<a {...props} {href} class="group relative flex overflow-hidden {props?.class}">
  <span class="ease-link transition-transform duration-[0.6s] group-hover:-translate-y-full">
    <slot />
  </span>

  <span
    class="ease-navLink absolute left-0 translate-y-full opacity-100 transition-transform duration-[0.6s] group-hover:translate-y-0"
  >
    <slot />
  </span>
</a>
